import { contentStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent";
import { css } from "styled-components";

Object.assign(contentStyles, {
    container: {
        css: css`
            margin: 30px 0;
        `,
    },
});
